<template>
  <div>
    <!-- 선택된 옵션 리스트 -->
    <ul style="list-style:none">
      <li class="lp-prod-option-box" v-for="(option,idx) in tableItems" :key="'prop-opt-item-'+idx">
        <!-- 박스 -->
        <div class="lp-option-item">
          <div class="columns is-multiline">

            <!-- 옵션 내용 -->
            <div class="column is-full">

              <div style="padding:0;position: relative;" class="columns is-multiline">
                <!--                <div v-if="idx>0" class="opt-line"></div>-->
                <div class="flex-between" style="width:100%">
                  <div class="flex-align">
                    <div style="font-size:12px;background-color: white;border: 1px solid #ddd;padding: 2px;border-radius: 4px;">
                      {{ option.option_type === 0 ? '필수 선택 옵션' : '추가옵션' }}</div>
                    <div style="margin-left:10px">{{ option.name }}</div>
                  </div>
                  <div>{{ option.price|currency }}</div>
                </div>
                <div style="margin:12px 0">
                  <lp-radio :val.sync="option.enable_stock"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'재고 사용', value:true},{label:'무한대', value:false}]"></lp-radio>
                </div>
                <table style="width:100%;background-color: white">
                  <tr>
                    <th class="has-text-centered">입고</th>
                    <th class="has-text-centered">재고수량</th>
                    <th class="has-text-centered">주문수량</th>
                  </tr>
                  <tr>
                    <td class="has-text-centered">
                      <div v-if="option.enable_stock">
                        <input class="input product-short-input"
                               v-model="option.addCount"
                               @keyup.enter="addStock(option)"
                               type="number">
                        <button class="button is-primary" style="width:48px;margin-left: 4px" @click="addStock(option)">추가</button>
                      </div>
                      <div v-else style="text-align: center">-</div>
                    </td>
                    <td class="has-text-centered" style="line-height:36px">{{ option.enable_stock ? option.stock + '개'  : '-' }}</td>
                    <td class="has-text-centered" style="line-height:36px">{{ option.ordered_count ? option.ordered_count : 0 }}개</td>
                  </tr>
                </table>
              </div>
            </div>

          </div>
        </div>

      </li>
    </ul>
  </div>
</template>

<script>
  import LpOptPopup from "../../module/common/LpOptPopup";
  import { SweetModal } from "sweet-modal-vue";
  import LpModal from "../../module/common/LpModal.vue";
  import LpCheckBool from "./LpCheckBool";
  import LpRadio from "./LpRadio";

  export default {
    name: 'LaunchpackProductOptionStocks',
    props: {
      requiredOptionStockUsing: {
        type: Boolean,
        default: false
      },
      requiredOptionTitle: {
        type: String,
        required: false
      },
      selectors: {
        type: Array,
        required: true
      }
    },
    components: {
      LpRadio,
      LpCheckBool,
      LpOptPopup,
      SweetModal,
      LpModal
    },
    created() {
      if(this.selectors) this.tableItems = this.selectors;

    },
    data() {
      return {
        // 상품 옵션
        tableItems: []
      }
    },
    watch: {
      selectors(n) {
        this.tableItems = n;
      }
    },
    computed: {
      requiredOptionList() {
        let items = this.tableItems.filter(item => {
          return item.option_type===0;
        })
        return items;
      },
      addOptionList() {
        let items = this.tableItems.filter(item => {
          return item.option_type===1;
        })
        return items;
      }
    },
    methods: {
      checkRequiredOption (value) {
        this.$emit('checkRequiredOption', value);
      },
      // 추가옵션 재고 체크
      checkAddOption (item) {
        console.log(item)
      },
      addStock(item) {
        item.add = parseInt(item.add ? item.add : 0) + parseInt(item.addCount);
        if(item.stockCount === 0) {
          item.stockCount = item.stock;
        }
        item.stock = item.stockCount + item.add;
        item.addCount = 0;
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .product-short-input
    width 89px

  .lp-option-item
    font-size 0.9rem
    margin-top 12px

  .lp-option-item div
    margin auto 0

  .lp-option-item div:last-child
    margin-right 0

  .btn-add-option
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem

  .close-option
    cursor pointer
    font-size 18px
    color #787878

  .close-option:hover
    color #000

  .content table td, .content table th
    border-width 0
    padding 0
  .content table th
    padding-top 12px

  .content table
    width 100%

  .opt-line
    width 100%
    height 1px
    background-color #ccc
    margin-bottom 12px !important

  .box-opt
    background-color #f5f5f5
    padding 16px
    border-radius 3px
    margin-bottom 12px
  .box-opt:last-child
    margin-bottom 0

  .lp-prod-option-box
    background-color #f4f4f4
    padding 6px
    font-size 12px
    margin-bottom 8px

  .lp-prod-option-box th,
  .lp-prod-option-box td
    border 1px solid #dbdbdb
    padding 0.5em 0.75em

</style>
